import React from "react"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>© {new Date().getFullYear()} LS-DA S.A.S</span>
          <span style={{ opacity: 0.6 }}>Portal Administrativo v2.0</span>
        </div>
      </footer>
    </React.Fragment>
  )
}

export default Footer
